import type { IUser, IGetWallet } from '@tacans/shared-marketplace-layer';
import { useCallback } from 'react';
import {
    selectUserList,
    fetchUsersByWalletsThunk,
    fetchUsersByIdsThunk,
} from 'src/features/common/user/ducks/user-list';
import { useAppDispatch, useAppSelector } from 'src/hooks/app';
import { actions } from '../ducks/user-list/user-list.slice';

export function useFetchUserList() {
    const dispatch = useAppDispatch();
    const userListEntities = useUserListEntities();

    return useCallback(
        async ({ wallets, userIds }: { wallets?: IGetWallet[]; userIds?: IUser['id'][] }) => {
            const filteredUsers = userIds?.filter((item) => !userListEntities[item]) ?? [];
            const filteredWallets = wallets?.filter((item) => item && !userListEntities[item.address]) ?? [];

            if (filteredUsers.length || filteredWallets.length) {
                clearTimeout(useFetchUserList.fetchUsersRef);
                useFetchUserList.fetchUsersList.userIds = [
                    ...new Set([...useFetchUserList.fetchUsersList.userIds, ...filteredUsers]),
                ];
                useFetchUserList.fetchUsersList.wallets = [
                    ...new Set([...useFetchUserList.fetchUsersList.wallets, ...filteredWallets]),
                ];
                useFetchUserList.fetchUsersRef = setTimeout(async () => {
                    if (useFetchUserList.fetchUsersList.wallets.length) {
                        actions.startFetchingByWallets(useFetchUserList.fetchUsersList.wallets);
                        await dispatch(fetchUsersByWalletsThunk(useFetchUserList.fetchUsersList.wallets));
                        useFetchUserList.fetchUsersList.wallets = [];
                    }
                    if (useFetchUserList.fetchUsersList.userIds.length) {
                        actions.startFetchingByUserIds(useFetchUserList.fetchUsersList.userIds);
                        await dispatch(fetchUsersByIdsThunk(useFetchUserList.fetchUsersList.userIds));
                        useFetchUserList.fetchUsersList.userIds = [];
                    }
                });
            }
        },
        [dispatch, userListEntities]
    );
}

useFetchUserList.fetchUsersList = {
    wallets: [] as IGetWallet[],
    userIds: [] as string[],
};
useFetchUserList.fetchUsersRef = null as any;

export const useUserListEntities = () => useAppSelector(selectUserList);
